import React, { Component } from 'react';
import propTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import Alert from 'client/components/Be/Alert';
import { ModalButton, ModalFormattedObject } from 'client/components/Helpers/Modal';
import { isApiValidationResultError, responseToErrorMessage } from 'client/redux/apiHelpers';

class BeRemoteErrorAlert extends Component {

  static propTypes = {
    error: propTypes.object,
    ignoreValidationResult: propTypes.bool,
    icon: propTypes.bool,
    canShowDetails: propTypes.bool,
    showFullError: propTypes.bool,
  };

  static defaultProps = {
    className: '',
    icon: true,
  };

  getCode (error) {
    return _.get(error, 'response.code', null) || error.status || '';
  }

  getVisibleErrorObject (error) {
    const response = _.get(error, 'response');
    if (response && typeof response === 'object') return response;
    return error;
  }

  stringifyVisibleErrorObject (error) {
    const visibleErrorObject = this.getVisibleErrorObject(error);
    try {
      return JSON.stringify(visibleErrorObject, null, 2);
    } catch (err) {
      return 'Could not stringify error payload';
    }
  }

  render () {
    const { error, canShowDetails, ignoreValidationResult, className, icon, showFullError } = this.props;
    if (!error) return null;
    if (isApiValidationResultError(error) && ignoreValidationResult) return null;
    let message = responseToErrorMessage(_.get(error, 'response', {}), false);
    if (!message) message = responseToErrorMessage(error, true);
    const classes = classNames('alert-contrast', className);
    return (
      <Alert alertType="danger" className={classes} icon={icon}>
        <strong>Error {this.getCode(error)}: </strong> {message}
        {showFullError && (
          <pre className="well xs-mt-10 xs-mb-0" style={{whiteSpace: 'pre-wrap', wordBreak: 'break-word'}}>
            {this.stringifyVisibleErrorObject(error)}
          </pre>
        )}
        {canShowDetails && (
          <div className="xs-mt-10">
            <ModalButton
              className="btn btn-default btn-xs"
              ModalComponent={ModalFormattedObject}
              modalProps={{object: error, title: 'Error Details', inspector: 'object'}}
            >
              <i className="icon mdi mdi-search xs-mr-0"></i>
              {' '}Details
            </ModalButton>
          </div>
        )}
      </Alert>
    );
  }

}

export default BeRemoteErrorAlert;
